import PropTypes from 'prop-types';
import BarList from './BarList';
import { parseLCABreakdownFormData } from '@/utils/analysisUtils';

const FeedstockAttributionPanel = ({ feedstockCosts, unit, streams }) => {
  if (!feedstockCosts || feedstockCosts.length === 0) {
    return null;
  }

  const results = parseLCABreakdownFormData(feedstockCosts);

  if (!results || results.length === 0) {
    return null;
  }

  const title = streams
    ? `Cost of incoming ${streams} by upstream module`
    : 'Cost of incoming streams by upstream module';

  return (
    <BarList
      title={title}
      subtitle="The cost of the streams delivered to this module, split across the upstream modules that produced them"
      items={results}
      valueUnit={unit}
      valueDigits={2}
    />
  );
};

FeedstockAttributionPanel.propTypes = {
  feedstockCosts: PropTypes.array,
  unit: PropTypes.string,
  streams: PropTypes.string,
};

export default FeedstockAttributionPanel;
